
@switch (columnId) {
  @case (FundingTransactionOrderBy.DateCreated) {
    <lib-date-time-label [dateUtc]="element.dateCreated"></lib-date-time-label>
  }
  @case ('type') {
    <lib-text-table-column>
      {{ displayTextForTransactionType }}
    </lib-text-table-column>
  }
  @case ('status') {
    <lib-transaction-status-chip
      [status]="element?.status">
    </lib-transaction-status-chip>
  }
  @case (FundingTransactionOrderBy.Amount) {
    <lib-text-table-column>
      {{ element.amount | vituCurrencyUsd }}
    </lib-text-table-column>
  }
  @case (FundingTransactionOrderBy.PayerName) {
    <lib-text-table-column>
      {{ getDisplayTextForPayerName() }}
    </lib-text-table-column>
  }
  @case (FundingTransactionOrderBy.CardBrand) {
    @if (element.card?.cardBrand) {
      <span class="card-image">
        <i [class]="'fab fa-cc-' + element.card.cardBrand.toLowerCase() + ' fa-2x'"></i>
      </span>
    }
    @if (!element.card?.cardBrand) {
      <lib-text-table-column>
      </lib-text-table-column>
    }
  }
  @case (FundingTransactionOrderBy.CardNumber) {
    <lib-text-table-column>
      {{ getDisplayTextForCardNumber() }}
    </lib-text-table-column>
  }
  @case (FundingTransactionOrderBy.TransactionId) {
    <lib-text-table-column>
      {{ element.id }}
    </lib-text-table-column>
  }
  @case ('feesOnly') {
    <lib-binary-status-icon
      [value]="element?.feesOnly"
      [showPositiveOnly]="true">
    </lib-binary-status-icon>
  }
  @case ('DigitalWallet') {
    <lib-digital-wallet-image-table-column
      [kind]="element.digitalWallet">
    </lib-digital-wallet-image-table-column>
  }
  @default {
  }
}
